import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tag } from '../../../../accounts-v2/models/tag.model';

@Component({
  selector: 'app-assign-tag-dialog',
  templateUrl: 'assign-tag-dialog.component.html',
  styles: [
    `
      .tagHeader {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
    `,
  ],
})
export class AssignTagDialogComponent implements OnInit {

  @Input() showDialog: boolean = false;
  @Input() set tagList(list: Tag[]) {
    if (list && list.length) {
      this.tags = list;
      this.filteredTags = this.tags;
      this.tableConfig = {
        pageSize: 5,
        first: 0,
      };
    }
  }

  @Input() selectedTags: Tag[] = [];

  @Output() assignedTag: EventEmitter<Tag[]> = new EventEmitter<Tag[]>();
  @Output() addNewTag: EventEmitter<void> = new EventEmitter<void>();
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  tableConfig = {
    pageSize: 5,
    first: 0,
  };

  filterOptions: { name: string; id: number }[] = [
    { name: 'Assigned', id: 1 },
    { name: 'UnAssigned', id: 2 },
    { name: 'All', id: 3 },
  ];
  selectedFilterOption:{name:string,id:number};
  tags: Tag[] = [];
  filteredTags: Tag[] = [];

  ngOnInit(): void {
    this.selectedFilterOption =  { name: 'All', id: 3 };
  }

  selectedTagType(event: any) {
    if (event?.value) {
      if (event?.value?.id == 1) {
        this.filteredTags = JSON.parse(JSON.stringify(this.selectedTags));
        this.tableConfig.first = 0;
      } else if (event?.value?.id == 2) {
        this.filteredTags = this.tags.filter((data) => {
          return !this.selectedTags.find((item) => {
            return item?.name == data?.name;
          });
        });
      } else if (event?.value?.id == 3) {
        this.filteredTags = JSON.parse(JSON.stringify(this.tags));
      }
    }
  }

  emitAddNewTag(): void {
    this.addNewTag.emit();
  }

  cancelTagDialog() {
    this.showDialog = false;
    this.closed.emit();
  }

  assignSelectedTag() {
    this.showDialog = false;
    this.assignedTag.emit(this.selectedTags);
  }
}
